import docSignStyles from "../../../styles/documentSigning/DocSign.filters.module.css"
import LayoutButton from "../Common/LayoutButton"
import FilterButton from "../Common/FilterButton"
import { useContext } from "react"
import { UserContext } from "../../../context/userContext"

const RequestsFilterHeader = ({
  users,
  myStaffProfile,
  appliedQuickFilter,
  layoutOption,
  setLayoutOptionCallBack,
  getRequestsCallBack,
  newRequestCallBack,
  currentSortOption,
  currentSortDirection,
  onSetAppliedFilters,
  isLoading,
}) => {
  const userCtx = useContext(UserContext)

  return (
    <div className={docSignStyles.filterHeaderGridContainer}>
      <div className={docSignStyles.filterHeaderGridTitle}>
        <label>Filters & Sorting</label>
      </div>
      <div className={docSignStyles.filterHeaderGridButtons}>
        <div className={docSignStyles.filterButtonContainer}>
          <LayoutButton
            iconName="menu"
            toolTip="Display templates as a table"
            value="table"
            layoutOption={layoutOption}
            setLayoutOption={setLayoutOptionCallBack}
            disabled={isLoading}
          />
          <LayoutButton
            iconName="apps"
            toolTip="Display templates as a grid"
            value="grid"
            layoutOption={layoutOption}
            setLayoutOption={setLayoutOptionCallBack}
            disabled={isLoading}
          />
        </div>
        <div className={docSignStyles.filterButtonContainer}>
          <FilterButton
            iconName="refresh"
            toolTip="Refresh page"
            onClickCallBack={() => {
              getRequestsCallBack()
            }}
            disabled={isLoading}
          />
        </div>
        <div className={docSignStyles.filterButtonContainer}>
          <FilterButton
            iconName="folder_copy"
            toolTip="Show requests assigned to me"
            onClickCallBack={() => {
              onSetAppliedFilters(
                {
                  dateCreated: [],
                  search: "",
                  staff: [myStaffProfile],
                  participants: [],
                  status: "all",
                  sort: currentSortOption,
                  sortDirection: currentSortDirection,
                },
                "my_requests"
              )
            }}
            disabled={isLoading}
            doHighlight={appliedQuickFilter === "my_requests"}
          />
          <FilterButton
            iconName="group"
            toolTip="Show requests assigned to my participants"
            onClickCallBack={() => {
              const participants = users.filter(
                (users) => users.name === "Participants"
              )

              if (participants.length > 0) {
                const myParticipants = participants[0].items.filter(
                  (part) => part.myParticipant
                )

                if (myParticipants.length > 0) {
                  onSetAppliedFilters(
                    {
                      dateCreated: [],
                      search: "",
                      staff: [],
                      participants: myParticipants,
                      status: "all",
                      sort: currentSortOption,
                      sortDirection: currentSortDirection,
                    },
                    "my_participants"
                  )
                } else {
                  userCtx.setNotificationError("No participants found")
                }
              } else {
                userCtx.setNotificationError("No participants found")
              }
            }}
            disabled={isLoading}
            doHighlight={appliedQuickFilter === "my_participants"}
          />
          <FilterButton
            iconName="edit_note"
            toolTip="Show requests that are awaiting my Signature"
            onClickCallBack={() => {
              onSetAppliedFilters(
                {
                  dateCreated: [],
                  search: "",
                  staff: [myStaffProfile],
                  participants: [],
                  status: "awaiting_signature",
                  sort: currentSortOption,
                  sortDirection: currentSortDirection,
                },
                "awaiting_my_signature"
              )
            }}
            disabled={isLoading}
            doHighlight={appliedQuickFilter === "awaiting_my_signature"}
          />
        </div>
        <div className={docSignStyles.filterButtonContainer}>
          <FilterButton
            iconName="add"
            toolTip="New Request"
            onClickCallBack={() => {
              newRequestCallBack()
            }}
            disabled={isLoading}
          />
        </div>
      </div>
    </div>
  )
}
export default RequestsFilterHeader
